import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Tem {{length}} alertas',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Informação de pagamento em análise',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Informação de pagamento verificada',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Erro na informação de pagamento',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'A sua informação de pagamento está a ser analisada pelo Stripe. Este processo pode demorar até 48 horas.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'A sua informação de pagamento foi verificada com sucesso. Pode agora receber pagamentos.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Parece que ocorreu um erro com os seus dados. Por favor clique aqui para atualizar a sua informação.',
    },
  },
};
